module.exports = __webpack_public_path__ + "img/home_background.0113d9d1.png";